import React from "react";
import { round } from "lodash";
import { Center, Column, Row } from "@/shared/ui/Blocks";
import { Score } from "@/shared/services/api/graphql/generated";
import ScoreChartCompact from "../Charts/ScoreChart/ScoreChart.compact";
import { SubtitleText } from "@/shared/ui/Typography";
import { PersonScore } from "@/features/people/hooks/useDimensionsWithScores";

interface DimensionCardProps {
  id: number;
  title?: string;
  description?: string;
  scores: PersonScore[];
  score?: Score;
  averageScore?: Score;
  badgeText?: string;
  badgeType?: "good" | "neutral" | "warning";
  showScore?: boolean;
  showAverageScore?: boolean;
  scoreMultiplier?: number;
}

function DimensionCard(props: DimensionCardProps) {
  const {
    title,
    scores,
    description,
    showScore,
    showAverageScore,
    score,
    averageScore,
    scoreMultiplier = 1,
  } = props;

  const renderScore = (score: Score) => (
    <Center className="w-[20px] aspect-square bg-black rounded-full text-xs leading-tight text-white font-semibold">
      <span>{round(score.value || 0)}</span>
    </Center>
  );

  return (
    <Column className="gap-4 not-prose">
      <Row className="gap-4 rounded-md items-center justify-between">
        <p className="text-sm font-semibold text-grey-900">{title}</p>
        <div className="relative w-[145px] h-[20px]">
          <ScoreChartCompact
            renderScore={renderScore}
            scores={scores}
            score={showScore ? score : undefined}
            showArea
            areaColor="blue"
            scoreMultiplier={scoreMultiplier}
            averageScore={(!!showAverageScore && averageScore?.value) || 0}
          />
        </div>
      </Row>
      <SubtitleText className="text-sm">{description}</SubtitleText>
    </Column>
  );
}

export { DimensionCard };
